<template>
  <a :class="badgeClass">
    <font-awesome-icon :icon="icon" />
    {{ appointmentNumber.replace(/^0+/, "") }}
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    appointmentNumber: {
      type: [Number, String],
      required: true,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-success",
      icon: ["fal", "calendar-day"],
    };
  },

  computed: {
    badgeClass() {
      return `badge badge-readable ${this.color} ${this.size}`;
    },
  },
};
</script>
